import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14516568"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Регистрация почти завершена. На Вашу почту был отправлен код подтверждения, укажите его. ", -1))
const _hoisted_2 = { class: "text-center" }

import { reactive, ref } from 'vue'
import { ElNotification, FormInstance, FormRules } from 'element-plus'
import useFormRequest from '@/composables/useFormRequest'
import { confirmRegister } from '@/store/actions/auth'
import { iConfirmRegisterForm } from '@/types/common/requests'

interface iFormState {
  code: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationConfirmForm',
  props: {
    email: {}
  },
  emits: ['verified'],
  setup(__props: any, { emit: __emit }) {


const props = __props

const formRef = ref<FormInstance>()
const formRequest = useFormRequest<iConfirmRegisterForm>()
const emit = __emit

const form = reactive<iFormState>({
  code: ''
})

const rules = reactive<FormRules<iFormState>>({
  code: [
    { required: true, message: 'Обязательно для заполнения', trigger: 'blur' }
  ]
})

const handleSubmit = async () => {
  await formRef.value?.validate(valid => {
    if (valid) {
      formRequest.tryRequest(async () => {
        await confirmRegister({
          code: form.code,
          email: props.email
        })
        ElNotification({ message: 'Email подтвержден, выполните вход', type: 'success' })
        emit('verified')
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { class: "card" }, {
            header: _withCtx(() => [
              _createTextVNode("Регистрация")
            ]),
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                model: form,
                rules: rules,
                ref_key: "formRef",
                ref: formRef,
                "status-icon": "",
                onSubmit: _withModifiers(handleSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_el_form_item, {
                    prop: "code",
                    error: _unref(formRequest).state.errors.code
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.code) = $event)),
                        placeholder: "Код из письма",
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          "native-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Подтвердить")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])), [
                [_directive_loading, _unref(formRequest).state.pending]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})